export const PRICE_OFF = 'Off';
export const IMAGE_ALT = 'Price Reveal Banner Image';
export const IMAGE_WIDTH = 308;
